import React from 'react';

const CollapsiblePanelIcon = ({
  size = 22,
  color = 'currentColor',
  strokeWidth = 2,
  className = '',
  ariaLabel = '',
  ...props
}) => (
  <svg
    width={size}
    height={size * (18 / 22)}
    viewBox="-1 -1 24 20"
    fill="none"
    overflow="visible"
    xmlns="http://www.w3.org/2000/svg"
    className={`block shrink-0 ${className}`.trim()}
    aria-label={ariaLabel || undefined}
    role={ariaLabel ? 'img' : undefined}
    {...props}
  >
    <rect
      x="1"
      y="1"
      width="20"
      height="16"
      rx="3"
      stroke={color}
      strokeWidth={strokeWidth}
    />
    <line
      x1="8"
      y1="0"
      x2="8"
      y2="18"
      stroke={color}
      strokeWidth={strokeWidth}
    />
  </svg>
);

export default CollapsiblePanelIcon;
